export const benefitenefitAmount = [
	1500, 1450, 1400, 1350, 1300, 1250, 1200, 1150, 1100, 1050, 1000, 950, 900, 850, 800, 750, 700, 650, 600, 550, 500,
	450, 400, 350, 300, 250, 200, 150, 100
];

export const STDDependentsPlanDetails = {
	350: {
		"18-49": {
			WEEKLY: 10.06,
			MONTHLY: 10.06
		},
		"50-59": {
			WEEKLY: 10.06,
			MONTHLY: 10.06
		},
		"60-64": {
			WEEKLY: 10.06,
			MONTHLY: 10.06
		}
	},
	300: {
		"18-49": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"50-59": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"60-64": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		}
	},
	250: {
		"18-49": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"50-59": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"60-64": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		}
	},
	200: {
		"18-49": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"50-59": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"60-64": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		}
	},
	150: {
		"18-49": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"50-59": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"60-64": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		}
	},
	100: {
		"18-49": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"50-59": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		},
		"60-64": {
			WEEKLY: 8.9,
			MONTHLY: 8.9
		}
	}
};

export const STDPlanDetails = {
	coverage: [],
	benefit: [
		"Non-Occupational(Elim Period accident: 0 Sickness: 7 Benefit Period: 6 Months)",
		"Non-Occupational(Elim Period accident: 14 Sickness: 14 Benefit Period: 6 Months)"
	],
	benefit_amount: {
		"Employee Only": {
			"Non-Occupational(Elim Period accident: 0 Sickness: 7 Benefit Period: 6 Months)": {
				"100": {
					"18-49": {
						WEEKLY: 4.37,
						MONTHLY: 18.94
					},
					"50-59": {
						WEEKLY: 4.97,
						MONTHLY: 21.54
					},
					"60-64": {
						WEEKLY: 6.2,
						MONTHLY: 26.87
					}
				},
				"150": {
					"18-49": {
						WEEKLY: 6.56,
						MONTHLY: 28.43
					},
					"50-59": {
						WEEKLY: 7.46,
						MONTHLY: 32.33
					},
					"60-64": {
						WEEKLY: 9.29,
						MONTHLY: 40.26
					}
				},
				"200": {
					"18-49": {
						WEEKLY: 8.75,
						MONTHLY: 37.92
					},
					"50-59": {
						WEEKLY: 9.95,
						MONTHLY: 43.12
					},
					"60-64": {
						WEEKLY: 12.39,
						MONTHLY: 53.69
					}
				},
				"250": {
					"18-49": {
						WEEKLY: 10.93,
						MONTHLY: 47.36
					},
					"50-59": {
						WEEKLY: 12.43,
						MONTHLY: 53.86
					},
					"60-64": {
						WEEKLY: 15.49,
						MONTHLY: 67.12
					}
				},
				"300": {
					"18-49": {
						WEEKLY: 13.12,
						MONTHLY: 56.85
					},
					"50-59": {
						WEEKLY: 14.92,
						MONTHLY: 64.65
					},
					"60-64": {
						WEEKLY: 18.59,
						MONTHLY: 80.56
					}
				},
				"350": {
					"18-49": {
						WEEKLY: 15.31,
						MONTHLY: 66.34
					},
					"50-59": {
						WEEKLY: 17.41,
						MONTHLY: 75.44
					},
					"60-64": {
						WEEKLY: 21.69,
						MONTHLY: 93.99
					}
				},
				"400": {
					"18-49": {
						WEEKLY: 17.49,
						MONTHLY: 75.79
					},
					"50-59": {
						WEEKLY: 19.89,
						MONTHLY: 86.19
					},
					"60-64": {
						WEEKLY: 24.78,
						MONTHLY: 107.38
					}
				},
				"450": {
					"18-49": {
						WEEKLY: 19.68,
						MONTHLY: 85.28
					},
					"50-59": {
						WEEKLY: 22.38,
						MONTHLY: 96.98
					},
					"60-64": {
						WEEKLY: 27.88,
						MONTHLY: 120.81
					}
				},
				"500": {
					"18-49": {
						WEEKLY: 21.87,
						MONTHLY: 94.77
					},
					"50-59": {
						WEEKLY: 24.86,
						MONTHLY: 107.73
					},
					"60-64": {
						WEEKLY: 30.98,
						MONTHLY: 134.25
					}
				},
				"550": {
					"18-49": {
						WEEKLY: 24.05,
						MONTHLY: 104.22
					},
					"50-59": {
						WEEKLY: 27.35,
						MONTHLY: 118.52
					},
					"60-64": {
						WEEKLY: 34.08,
						MONTHLY: 147.68
					}
				},
				"600": {
					"18-49": {
						WEEKLY: 26.24,
						MONTHLY: 113.71
					},
					"50-59": {
						WEEKLY: 29.84,
						MONTHLY: 129.31
					},
					"60-64": {
						WEEKLY: 37.18,
						MONTHLY: 161.11
					}
				},
				"650": {
					"18-49": {
						WEEKLY: 28.42,
						MONTHLY: 123.15
					},
					"50-59": {
						WEEKLY: 32.32,
						MONTHLY: 140.05
					},
					"60-64": {
						WEEKLY: 40.28,
						MONTHLY: 174.55
					}
				},
				"700": {
					"18-49": {
						WEEKLY: 30.61,
						MONTHLY: 132.64
					},
					"50-59": {
						WEEKLY: 34.81,
						MONTHLY: 150.84
					},
					"60-64": {
						WEEKLY: 43.37,
						MONTHLY: 187.94
					}
				},
				"750": {
					"18-49": {
						WEEKLY: 32.8,
						MONTHLY: 142.13
					},
					"50-59": {
						WEEKLY: 37.3,
						MONTHLY: 161.63
					},
					"60-64": {
						WEEKLY: 46.47,
						MONTHLY: 201.37
					}
				},
				"800": {
					"18-49": {
						WEEKLY: 34.98,
						MONTHLY: 151.58
					},
					"50-59": {
						WEEKLY: 39.78,
						MONTHLY: 172.38
					},
					"60-64": {
						WEEKLY: 49.57,
						MONTHLY: 214.8
					}
				},
				"850": {
					"18-49": {
						WEEKLY: 37.17,
						MONTHLY: 161.07
					},
					"50-59": {
						WEEKLY: 42.27,
						MONTHLY: 183.17
					},
					"60-64": {
						WEEKLY: 52.67,
						MONTHLY: 228.24
					}
				},
				"900": {
					"18-49": {
						WEEKLY: 39.36,
						MONTHLY: 170.56
					},
					"50-59": {
						WEEKLY: 44.76,
						MONTHLY: 193.96
					},
					"60-64": {
						WEEKLY: 55.77,
						MONTHLY: 241.67
					}
				},
				"950": {
					"18-49": {
						WEEKLY: 41.54,
						MONTHLY: 180.01
					},
					"50-59": {
						WEEKLY: 47.24,
						MONTHLY: 204.71
					},
					"60-64": {
						WEEKLY: 58.86,
						MONTHLY: 255.06
					}
				},
				"1000": {
					"18-49": {
						WEEKLY: 43.73,
						MONTHLY: 189.5
					},
					"50-59": {
						WEEKLY: 49.73,
						MONTHLY: 215.5
					},
					"60-64": {
						WEEKLY: 61.96,
						MONTHLY: 268.49
					}
				},
				"1050": {
					"18-49": {
						WEEKLY: 45.92,
						MONTHLY: 198.99
					},
					"50-59": {
						WEEKLY: 52.22,
						MONTHLY: 226.29
					},
					"60-64": {
						WEEKLY: 65.06,
						MONTHLY: 281.93
					}
				},
				"1100": {
					"18-49": {
						WEEKLY: 48.1,
						MONTHLY: 208.43
					},
					"50-59": {
						WEEKLY: 54.7,
						MONTHLY: 237.03
					},
					"60-64": {
						WEEKLY: 68.16,
						MONTHLY: 295.36
					}
				},
				"1150": {
					"18-49": {
						WEEKLY: 50.29,
						MONTHLY: 217.92
					},
					"50-59": {
						WEEKLY: 57.19,
						MONTHLY: 247.82
					},
					"60-64": {
						WEEKLY: 71.26,
						MONTHLY: 308.79
					}
				},
				"1200": {
					"18-49": {
						WEEKLY: 52.48,
						MONTHLY: 227.41
					},
					"50-59": {
						WEEKLY: 59.68,
						MONTHLY: 258.61
					},
					"60-64": {
						WEEKLY: 74.35,
						MONTHLY: 322.18
					}
				},
				"1250": {
					"18-49": {
						WEEKLY: 54.66,
						MONTHLY: 236.86
					},
					"50-59": {
						WEEKLY: 62.16,
						MONTHLY: 269.36
					},
					"60-64": {
						WEEKLY: 77.45,
						MONTHLY: 335.62
					}
				},
				"1300": {
					"18-49": {
						WEEKLY: 56.85,
						MONTHLY: 246.35
					},
					"50-59": {
						WEEKLY: 64.65,
						MONTHLY: 280.15
					},
					"60-64": {
						WEEKLY: 80.55,
						MONTHLY: 349.05
					}
				},
				"1350": {
					"18-49": {
						WEEKLY: 59.04,
						MONTHLY: 255.84
					},
					"50-59": {
						WEEKLY: 67.14,
						MONTHLY: 290.94
					},
					"60-64": {
						WEEKLY: 83.65,
						MONTHLY: 362.48
					}
				},
				"1400": {
					"18-49": {
						WEEKLY: 61.22,
						MONTHLY: 265.29
					},
					"50-59": {
						WEEKLY: 69.62,
						MONTHLY: 301.69
					},
					"60-64": {
						WEEKLY: 86.75,
						MONTHLY: 375.92
					}
				},
				"1450": {
					"18-49": {
						WEEKLY: 63.41,
						MONTHLY: 274.78
					},
					"50-59": {
						WEEKLY: 72.11,
						MONTHLY: 312.48
					},
					"60-64": {
						WEEKLY: 89.84,
						MONTHLY: 389.31
					}
				},
				"1500": {
					"18-49": {
						WEEKLY: 65.59,
						MONTHLY: 284.22
					},
					"50-59": {
						WEEKLY: 74.59,
						MONTHLY: 323.22
					},
					"60-64": {
						WEEKLY: 92.94,
						MONTHLY: 402.74
					}
				}
			},
			"Non-Occupational(Elim Period accident: 14 Sickness: 14 Benefit Period: 6 Months)": {
				"100": {
					"18-49": {
						WEEKLY: 2.87,
						MONTHLY: 12.44
					},
					"50-59": {
						WEEKLY: 3.37,
						MONTHLY: 14.6
					},
					"60-64": {
						WEEKLY: 4.22,
						MONTHLY: 18.29
					}
				},
				"150": {
					"18-49": {
						WEEKLY: 4.31,
						MONTHLY: 18.68
					},
					"50-59": {
						WEEKLY: 5.05,
						MONTHLY: 21.88
					},
					"60-64": {
						WEEKLY: 6.33,
						MONTHLY: 27.43
					}
				},
				"200": {
					"18-49": {
						WEEKLY: 5.75,
						MONTHLY: 24.92
					},
					"50-59": {
						WEEKLY: 6.74,
						MONTHLY: 29.21
					},
					"60-64": {
						WEEKLY: 8.45,
						MONTHLY: 36.62
					}
				},
				"250": {
					"18-49": {
						WEEKLY: 7.18,
						MONTHLY: 31.11
					},
					"50-59": {
						WEEKLY: 8.42,
						MONTHLY: 36.49
					},
					"60-64": {
						WEEKLY: 10.56,
						MONTHLY: 45.76
					}
				},
				"300": {
					"18-49": {
						WEEKLY: 8.62,
						MONTHLY: 37.35
					},
					"50-59": {
						WEEKLY: 10.11,
						MONTHLY: 43.81
					},
					"60-64": {
						WEEKLY: 12.67,
						MONTHLY: 54.9
					}
				},
				"350": {
					"18-49": {
						WEEKLY: 10.06,
						MONTHLY: 43.59
					},
					"50-59": {
						WEEKLY: 11.79,
						MONTHLY: 51.09
					},
					"60-64": {
						WEEKLY: 14.78,
						MONTHLY: 64.05
					}
				},
				"400": {
					"18-49": {
						WEEKLY: 11.49,
						MONTHLY: 49.79
					},
					"50-59": {
						WEEKLY: 13.48,
						MONTHLY: 58.41
					},
					"60-64": {
						WEEKLY: 16.89,
						MONTHLY: 73.19
					}
				},
				"450": {
					"18-49": {
						WEEKLY: 12.93,
						MONTHLY: 56.03
					},
					"50-59": {
						WEEKLY: 15.16,
						MONTHLY: 65.69
					},
					"60-64": {
						WEEKLY: 19,
						MONTHLY: 82.33
					}
				},
				"500": {
					"18-49": {
						WEEKLY: 14.37,
						MONTHLY: 62.27
					},
					"50-59": {
						WEEKLY: 16.85,
						MONTHLY: 73.02
					},
					"60-64": {
						WEEKLY: 21.11,
						MONTHLY: 91.48
					}
				},
				"550": {
					"18-49": {
						WEEKLY: 15.8,
						MONTHLY: 68.47
					},
					"50-59": {
						WEEKLY: 18.53,
						MONTHLY: 80.3
					},
					"60-64": {
						WEEKLY: 23.23,
						MONTHLY: 100.66
					}
				},
				"600": {
					"18-49": {
						WEEKLY: 17.24,
						MONTHLY: 74.71
					},
					"50-59": {
						WEEKLY: 20.22,
						MONTHLY: 87.62
					},
					"60-64": {
						WEEKLY: 25.34,
						MONTHLY: 109.81
					}
				},
				"650": {
					"18-49": {
						WEEKLY: 18.67,
						MONTHLY: 80.9
					},
					"50-59": {
						WEEKLY: 21.9,
						MONTHLY: 94.9
					},
					"60-64": {
						WEEKLY: 27.45,
						MONTHLY: 118.95
					}
				},
				"700": {
					"18-49": {
						WEEKLY: 20.11,
						MONTHLY: 87.14
					},
					"50-59": {
						WEEKLY: 23.58,
						MONTHLY: 102.18
					},
					"60-64": {
						WEEKLY: 29.56,
						MONTHLY: 128.09
					}
				},
				"750": {
					"18-49": {
						WEEKLY: 21.55,
						MONTHLY: 93.38
					},
					"50-59": {
						WEEKLY: 25.27,
						MONTHLY: 109.5
					},
					"60-64": {
						WEEKLY: 31.67,
						MONTHLY: 137.24
					}
				},
				"800": {
					"18-49": {
						WEEKLY: 22.98,
						MONTHLY: 99.58
					},
					"50-59": {
						WEEKLY: 26.95,
						MONTHLY: 116.78
					},
					"60-64": {
						WEEKLY: 33.78,
						MONTHLY: 146.38
					}
				},
				"850": {
					"18-49": {
						WEEKLY: 24.42,
						MONTHLY: 105.82
					},
					"50-59": {
						WEEKLY: 28.64,
						MONTHLY: 124.11
					},
					"60-64": {
						WEEKLY: 35.9,
						MONTHLY: 155.57
					}
				},
				"900": {
					"18-49": {
						WEEKLY: 25.86,
						MONTHLY: 112.06
					},
					"50-59": {
						WEEKLY: 30.32,
						MONTHLY: 131.39
					},
					"60-64": {
						WEEKLY: 38.01,
						MONTHLY: 164.71
					}
				},
				"950": {
					"18-49": {
						WEEKLY: 27.29,
						MONTHLY: 118.26
					},
					"50-59": {
						WEEKLY: 32.01,
						MONTHLY: 138.71
					},
					"60-64": {
						WEEKLY: 40.12,
						MONTHLY: 173.85
					}
				},
				"1000": {
					"18-49": {
						WEEKLY: 28.73,
						MONTHLY: 124.5
					},
					"50-59": {
						WEEKLY: 33.69,
						MONTHLY: 145.99
					},
					"60-64": {
						WEEKLY: 42.23,
						MONTHLY: 183
					}
				},
				"1050": {
					"18-49": {
						WEEKLY: 30.17,
						MONTHLY: 130.74
					},
					"50-59": {
						WEEKLY: 35.38,
						MONTHLY: 153.31
					},
					"60-64": {
						WEEKLY: 44.34,
						MONTHLY: 192.14
					}
				},
				"1100": {
					"18-49": {
						WEEKLY: 31.6,
						MONTHLY: 136.93
					},
					"50-59": {
						WEEKLY: 37.06,
						MONTHLY: 160.59
					},
					"60-64": {
						WEEKLY: 46.45,
						MONTHLY: 201.28
					}
				},
				"1150": {
					"18-49": {
						WEEKLY: 33.04,
						MONTHLY: 143.17
					},
					"50-59": {
						WEEKLY: 38.75,
						MONTHLY: 167.92
					},
					"60-64": {
						WEEKLY: 48.56,
						MONTHLY: 210.43
					}
				},
				"1200": {
					"18-49": {
						WEEKLY: 34.48,
						MONTHLY: 149.41
					},
					"50-59": {
						WEEKLY: 40.43,
						MONTHLY: 175.2
					},
					"60-64": {
						WEEKLY: 50.68,
						MONTHLY: 219.61
					}
				},
				"1250": {
					"18-49": {
						WEEKLY: 35.91,
						MONTHLY: 155.61
					},
					"50-59": {
						WEEKLY: 42.12,
						MONTHLY: 182.52
					},
					"60-64": {
						WEEKLY: 52.79,
						MONTHLY: 228.76
					}
				},
				"1300": {
					"18-49": {
						WEEKLY: 37.35,
						MONTHLY: 161.85
					},
					"50-59": {
						WEEKLY: 43.8,
						MONTHLY: 189.8
					},
					"60-64": {
						WEEKLY: 54.9,
						MONTHLY: 237.9
					}
				},
				"1350": {
					"18-49": {
						WEEKLY: 38.79,
						MONTHLY: 168.09
					},
					"50-59": {
						WEEKLY: 45.48,
						MONTHLY: 197.08
					},
					"60-64": {
						WEEKLY: 57.01,
						MONTHLY: 247.04
					}
				},
				"1400": {
					"18-49": {
						WEEKLY: 40.22,
						MONTHLY: 174.29
					},
					"50-59": {
						WEEKLY: 47.17,
						MONTHLY: 204.4
					},
					"60-64": {
						WEEKLY: 59.12,
						MONTHLY: 256.19
					}
				},
				"1450": {
					"18-49": {
						WEEKLY: 41.66,
						MONTHLY: 180.53
					},
					"50-59": {
						WEEKLY: 48.85,
						MONTHLY: 211.68
					},
					"60-64": {
						WEEKLY: 61.23,
						MONTHLY: 265.33
					}
				},
				"1500": {
					"18-49": {
						WEEKLY: 43.1,
						MONTHLY: 186.77
					},
					"50-59": {
						WEEKLY: 50.54,
						MONTHLY: 219.01
					},
					"60-64": {
						WEEKLY: 63.34,
						MONTHLY: 274.47
					}
				}
			}
		}
	}
};
